import styled from "@emotion/styled";

const Input = styled.input`
  padding: 6px;
  border: 1px solid #e2e4e7;
  border-radius: 3px;
  transition: border-color 0.3s;
  outline: none;

  &:hover {
    border-color: #1976d2;
  }

  &:focus {
    border-color: #1976d2;
  }
`;

const Label = styled.div`
  display: flex;
  text-align: left;
  width: 140px;
  flex-shrink: 0;
  font-family: "Charlie Sans", sans-serif;
  font-size: 12px;
  font-weight: bold;
`;

const Astrik = styled.span`
  color: red;
`;

const LabelContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  gap: 18px;
  margin: 0px 0px 18px 0px;
`;

const Children = styled.div`
  flex: 1;
  min-width: 0;
`;

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  padding: 0px;
`;

const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 320px;
  padding: 28px 20px 0px;
`;

const FormSection = styled.div`
  flex: 1;
`;

const ActionBar = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 18px 0px 8px;
`;

const CheckboxRow = styled.div`
  display: flex;
  align-items: center;
  font-family: "Charlie Sans", sans-serif;
  font-size: 12px;
  color: #172b4d;
`;

const SC = {
  Input,
  Astrik,
  LabelContainer,
  Children,
  Wrapper,
  Label,
  ModalBody,
  FormSection,
  ActionBar,
  CheckboxRow,
};

export default SC;
